import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { initalizeApp } from './app/app.config'

initalizeApp().then((config) => {
  bootstrapApplication(AppComponent, config).catch((err) => console.error(err))
})
